export default {
  MuiPaginationItem: {
    styleOverrides: {
      root: {
        minWidth: '24px',
        height: '24px',
        '&.Mui-selected': {
          backgroundColor: 'rgba(0,0,0,0)',
          border: 'solid 1px #000000',
          borderRadius: '2px',
          color: '#095ca8'
        }
      },
      previousNext: {
        '& > svg': {
          fontSize: '14px'
        }
      }
    }
  }
};
